module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAVCAYAAABYHP4bAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAARpJREFUeNq0lYERgjAMRcFzAEZgBDYQJ5ARcANGYANGwA2UCdAJcAPYADeIiQbM9dCmgP8u13IXeE1Dfz1vgQAgw2jgI5qnRk6KEcmH0gEQGABTNUaB0VLIF8+cUCpBBejUYyRjlbwCuZrgByQEvXoeJ0FDQvYFlICbUs1W0B7nYzPfubkDJJ/ajl6xDbXop1M1Gx4TjIvlH6C+xZyrVTdMtjwe+CNr62FWVP0D4vv+3QSdJH0lXeXDC4RkguxXhlU276phuVqbtawBAdNYp0CR4jzZ1GidOWJHmCNaZOh61ySOwF5alRaSWu4bZ4hPK8dxSNrxPHA8L0c8Ip2mgnxGX1rr3yUrMvsiqoonfIss5UYGLO1Fo6cAAwCsa6nzYSZKgAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/SocialImg/twitterLogo.png
// module id = 563
// module chunks = 153596302435155